<template>
  <div class="d-flex flex-wrap align-items-center">
    <div class="mr-auto">
      <p class="text-uppercase text-dark font-weight-bold mb-1">
        {{title}}
      </p>
      <p class="text-gray-5 mb-0">
        {{subtitle}}
      </p>
    </div>
    <p class="text-success font-weight-bold font-size-24 mb-0">
      {{amount}}
    </p>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      default: 'Total',
    },
    amount: {
      default: '0000,00',
    },
    subtitle: {
      default: '',
    },
  },
}
</script>
